"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var owa_format_options_1 = require("owa-format-options");
// default composing font family (this should match the Calibri font in the FONT_NAME_LIST in FontName.ts), font size and text color
var DEFAULT_FONT_FAMILY = 'Calibri,Arial,Helvetica,sans-serif';
var DEFAULT_FONT_SIZE = '11pt';
var DEFAULT_TEXT_COLOR = '#000000';
var DEFAULT_FORMAT = {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: DEFAULT_FONT_SIZE,
    textColor: DEFAULT_TEXT_COLOR,
    bold: false,
    italic: false,
    underline: false,
};
function getDefaultComposeFormat() {
    var userOption = getUserConfiguration_1.default().UserOptions;
    if (userOption) {
        return getComposeFormat(userOption.ComposeFontName, userOption.ComposeFontSize, userOption.ComposeFontColor, userOption.ComposeFontFlags);
    }
    else {
        return DEFAULT_FORMAT;
    }
}
exports.default = getDefaultComposeFormat;
function getComposeFormat(fontName, fontSize, fontColor, fontFlags) {
    var defaultFormat = tslib_1.__assign({}, DEFAULT_FORMAT);
    var composeFont = fontName ? owa_format_options_1.getFontFamily(fontName) : null;
    if (composeFont) {
        defaultFormat.fontFamily = composeFont;
    }
    var composeSize = fontSize ? owa_format_options_1.getFontSizeInPoints(fontSize) : null;
    if (composeSize) {
        defaultFormat.fontSize = composeSize;
    }
    if (fontColor) {
        defaultFormat.textColor = fontColor;
    }
    if (fontFlags) {
        defaultFormat.bold = (fontFlags & 1 /* Bold */) == 1 /* Bold */;
        defaultFormat.italic = (fontFlags & 2 /* Italic */) == 2 /* Italic */;
        defaultFormat.underline = (fontFlags & 4 /* Underline */) == 4 /* Underline */;
    }
    return defaultFormat;
}
exports.getComposeFormat = getComposeFormat;
//# sourceMappingURL=getDefaultComposeFormat.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-editor/lib/utils/getDefaultComposeFormat.js
// module id = 2188
// module chunks = 2 3 59 108